import { RouteLocationNormalized, RouteRecord } from "vue-router";
import { userManager } from "@/modules/authentication/user-manager";
import { ROUTE_AUTHENTICATION_LOGIN } from "@/modules/authentication/services/router/routes-names";
import { ROUTE_PROFILE } from "@/modules/profile/services/router/routes-names";
import { ERROR_ROUTE, ROUTE_LOGGED_HOME } from "@/services/router/router-names";
import { AFFILIATES_BASE } from "@/modules/affiliates/services/router/routes-names";
import { SUPPORTERS_STARTING_POINT_PROGRAM } from "@/modules/supporters/services/router/routes-names";
import { EAffiliatesActions } from "@/modules/affiliates/services/store/affiliates/affiliates.types";
import store from "@/services/store";

import { createLogger } from "@/utils/logger";
import { AFFILIATE_TARGET_ENTREPRENEUR } from "../data/affiliate/affiliate.interface";
const log = createLogger("SERVICE/ROUTER/AUTH_GAURD");

export const authenticationGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: any,
) => {
  const isAuthenticated = userManager.isLogged();
  const isGuestUser = to.matched.some((m: RouteRecord) => m.meta.guest);
  const hasNotVisitedLogin =
    to.matched.some((m: RouteRecord) => m.meta.auth) ||
    (to.name === ROUTE_PROFILE && !to.params.id);

  const isAffiliateRoute =
    Object.prototype.hasOwnProperty.call(to.query, "a") ||
    Object.prototype.hasOwnProperty.call(to.query, "sdg") ||
    Object.prototype.hasOwnProperty.call(to.query, "affiliate");

  // check if the user needs to be authenticated, if yes, and the users doesn't
  // have a session token redirect to the login page
  if (!isAuthenticated && hasNotVisitedLogin) {
    log.info("redirecting to login page");
    return next({
      name: ROUTE_AUTHENTICATION_LOGIN,
      query: { redirectTo: to.fullPath },
    });
  }

  // check if a logged user should see this page
  if (isAuthenticated && isGuestUser) {
    log.info("redirecting to home page");
    return next({ name: ROUTE_LOGGED_HOME });
  }

  // if user is logged and route has affiliate parameter redirect to correct affiliate flow
  log.info(`has affiliate parameter ${isAffiliateRoute}`);
  const affiliateShortCode = to.query.a ?? to.query.affiliate ?? to.query.sdg;
  const canNavigateToAffiliate =
    affiliateShortCode &&
    to.name !== AFFILIATES_BASE &&
    to.name !== SUPPORTERS_STARTING_POINT_PROGRAM;

  if (isAffiliateRoute && canNavigateToAffiliate) {
    log.info("fetching affiliate", affiliateShortCode);
    const affiliate = await store.dispatch(
      EAffiliatesActions.FETCH_AFFILIATE,
      affiliateShortCode,
    );

    if (affiliate) {
      const targetRoute =
        affiliate.flow_target === AFFILIATE_TARGET_ENTREPRENEUR
          ? AFFILIATES_BASE
          : SUPPORTERS_STARTING_POINT_PROGRAM;

      log.info("target route", targetRoute);
      return next({ name: targetRoute, query: to.query });
    } else {
      return next({ name: ERROR_ROUTE });
    }
  } else {
    next();
  }
};
